exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row h3[data-v-77e7e69c]{margin-bottom:0;font-weight:600}", ""]);

// exports
